
import React from "react";
import CommunicationIntegrationsModule from "@/components/admin/communication-hub/CommunicationIntegrationsModule";

const CommunicationIntegrationsManagement: React.FC = () => {
  return <CommunicationIntegrationsModule />;
};

export default CommunicationIntegrationsManagement;
